if (!("classList" in document.documentElement)) {
    Object.defineProperty(HTMLElement.prototype, 'classList', {
        get: function () {
            var self = this;
            function update(fn) {
                return function (value) {
                    var classes = self.className.split(/\s+/g),
                        index = classes.indexOf(value);

                    fn(classes, index, value);
                    self.className = classes.join(" ");
                }
            }

            return {
                add: update(function (classes, index, value) {
                    if (!~index) classes.push(value);
                }),

                remove: update(function (classes, index) {
                    if (~index) classes.splice(index, 1);
                }),

                toggle: update(function (classes, index, value) {
                    if (~index)
                        classes.splice(index, 1);
                    else
                        classes.push(value);
                }),

                contains: function (value) {
                    return !!~self.className.split(/\s+/g).indexOf(value);
                },

                item: function (i) {
                    return self.className.split(/\s+/g)[i] || null;
                }
            };
        }
    });
}
import '@babel/polyfill'
import Vue from 'vue'
import "classlist-polyfill"
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '../public/css/reset.css'
import "./assets/common.scss";
import "./utils/datetime.js";
import "./utils/utils.js";
import './eleconfig/element-var.scss'
import i18n from './locales'
import Router from 'vue-router'
import { ActionSheet } from "vant";
import { Toast } from "vant"
import store from './store/store.js'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAwesomeSwiper from "vue-awesome-swiper";

// require styles
// import "swiper/dist/css/swiper.css";
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper /* { default global options } */);
Vue.use(ElementUI);
Vue.use(ActionSheet);
Vue.use(Toast);

import { Field } from 'vant';
import { Popup } from 'vant';
import { Picker } from 'vant';
import { DatetimePicker } from 'vant';
import { Uploader } from 'vant';
import { Dialog } from 'vant';
import { Swipe, SwipeItem } from 'vant';
import { Lazyload } from 'vant';

Vue.use(Field);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Dialog);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
// 切换路由添加google统计
router.afterEach(function(to) {
    if (window.ga) {
    window.ga("set", "page", to.fullPath); // 你可能想根据请求参数添加其他参数，可以修改这里的 to.fullPath
    window.ga("send", "pageview");
    }
});

// Vue.filter('formatDate', function (value, formatString) {
//     if (!value) {
//         return value
//     } else {
//         formatString = formatString || 'YYYY-MM-DD HH:MM';
//         // return moment(value).format(formatString); // value可以是普通日期 20170723
//         return moment(value).format(formatString)
//     }

// });
// Vue.use(ElementUI);
// Vue.use(MintUI);
Vue.use(router)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
    render: (h) => h(App),
    router,
    store,
    i18n
}).$mount("#app");
